import { Stack } from '@mui/material'
import React, { FC, useContext } from 'react'

import { CenteredLoading } from '../../components'
import ServicesSummaryPanel from '../../components/InspectionRelatedPanel/ServicesSummaryPanel'
import VehicleInfoBox from '../../components/Vehicles/VehicleInfoBox'
import { RepairOrderContext } from '../../providers/RepairOrderProvider/RepairOrderProvider'
import SummaryPanelContainer from './SummaryPanelContainer'
const Sidebar: FC = () => {
  const { repairOrder, services, vehicle, vehicleImages, isLoading } =
    useContext(RepairOrderContext)
  const repairOrderId = repairOrder?.entry?.id

  return (
    <>
      {isLoading ? (
        <CenteredLoading />
      ) : (
        <Stack direction="column" spacing={2}>
          {repairOrder && vehicle && vehicleImages && (
            <VehicleInfoBox
              repairOrder={repairOrder}
              vehicle={vehicle}
              vehicleImages={vehicleImages}
            />
          )}
          {services && <ServicesSummaryPanel services={services} showPrice />}
          {repairOrderId && (
            <SummaryPanelContainer repairOrderId={repairOrderId} />
          )}
        </Stack>
      )}
    </>
  )
}

export default Sidebar
